import { Component, Input, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { PodcastService } from '../../../retalk/services/podcast.service';

@Component({
  selector: 'app-carousel-retalk-home',
  templateUrl: './carousel-retalk-home.component.html',
  styleUrls: ['./carousel-retalk-home.component.css']
})
export class CarouselRetalkHomeComponent implements OnInit, AfterViewInit {

  @Input() carouselMainImg: any = {}
  @Input() carouselRetalkHome_items: any[] = []
  @Input() podcastNumber: number = 0
  podcast: any;
  podcastUrl: string = ''
  podcastPoster: string = ''
  isComponentLoaded: boolean = false
  images: any[] = []

  constructor(private podcastService: PodcastService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

  }
  ngAfterViewInit(): void {
    this.podcastService.getPodcastWithImages(this.podcastNumber).subscribe(
      {
        next: (resp) => {
          this.podcast = resp;
          this.podcastUrl = '/retalk/' + this.podcast.id
          this.podcastPoster = "https://" + this.podcast.poster
          this.images = this.podcast.images.rows

          // this.carouselRetalkHome_items = []
          const imagesDistinctFromPoster = this.images.filter(image => image.location !== this.podcast.poster);

          imagesDistinctFromPoster.forEach((image, index) => {
            if (index < this.carouselRetalkHome_items.length) {
              this.carouselRetalkHome_items[index].imgSrc = "https://" + image.location;
            }
          });

          // this.carouselRetalkHome_items[0].imgSrc = "https://" + this.images[0].location
          // this.carouselRetalkHome_items[1].imgSrc = "https://" + this.images[1].location
          this.isComponentLoaded = true
          this.cdr.detectChanges();
        },
        error: (error) => {
          console.log(error)
          this.podcast = this.carouselRetalkHome_items[0]
        }
      }
    )
  }

}
